export function replaceItems(text: string, listToReplace: { search: string; replace: string }[]) {
    let result = text;
    listToReplace.forEach((item) => {
        result = result.replace(item.search, item.replace);
    });
    return result;
}
